<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>试用类型管理</span>
          <span class="muted small" style="margin-left: 10px">维护商品试用的类型选项（供商品管理中选择）</span>
          <div style="float: right">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openDialog()">新建试用类型</el-button>
          </div>
        </div>
      </template>

      <!-- 搜索/筛选 -->
      <el-form :inline="true" size="small" class="mb-3">
        <el-form-item label="类型名称">
          <el-input v-model="searchName" placeholder="输入名称搜索" clearable style="width: 180px"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchEnabled" placeholder="全部" clearable style="width: 120px">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="currentPage = 1">筛选</el-button>
          <el-button icon="el-icon-refresh" @click="searchName = ''; searchEnabled = null; currentPage = 1">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="filteredTypes"
        stripe
        size="small"
        border
        v-loading="loading"
        @row-dblclick="row => openDialog(row)"
      >
        <el-table-column label="排序" prop="sort" width="80" align="center"></el-table-column>
        <el-table-column label="试用类型名称" min-width="160">
          <template slot-scope="{ row }">
            <el-tag
              :color="row.color || ''"
              :style="row.color ? 'color:#fff;border-color:' + row.color : ''"
              size="small"
            >
              {{ row.name }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="颜色标识" width="130" align="center">
          <template slot-scope="{ row }">
            <span
              v-if="row.color"
              :style="'display:inline-block;width:16px;height:16px;border-radius:3px;background:' + row.color + ';vertical-align:middle;margin-right:6px'"
            ></span>
            <span class="muted">{{ row.color || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="核验要求" width="140" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.needVerification === 1 ? 'danger' : 'info'">
              {{ row.needVerification === 1 ? '需短信/附件核验' : '免核验' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.enabled === 1 ? 'success' : 'info'" effect="plain">
              {{ row.enabled === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注说明" prop="remark" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="{ row }">{{ formatDate(row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="ID" prop="id" width="80" align="center"></el-table-column>
        <el-table-column label="操作" width="160" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" @click="openDialog(row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="onDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新建 / 编辑弹窗 -->
    <el-dialog
      :title="form.id ? '编辑试用类型' : '新建试用类型'"
      :visible.sync="dialogVisible"
      width="580px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="120px" size="small">
        <el-form-item label="试用类型名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入类型名称，如：普通试用、预收试用、品鉴试用等" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="短信/附件核验">
          <el-switch
            v-model="form.needVerification"
            :active-value="1"
            :inactive-value="0"
            active-text="需要核验"
            inactive-text="免核验"
          ></el-switch>
          <div class="muted small" style="color:#909399;font-size:12px;line-height:1.4;margin-top:4px">
            开启后小程序端申请该类型需进行手机号短信验证码核验；无手机号时需走特殊通道上传附件
          </div>
        </el-form-item>
        <el-form-item label="标签颜色">
          <div style="display: flex; align-items: center">
            <el-color-picker v-model="form.color" :predefine="predefineColors"></el-color-picker>
            <span class="muted small" style="margin-left: 12px">用于在商品列表及下拉中标识该类型颜色</span>
          </div>
        </el-form-item>
        <el-form-item label="显示排序">
          <el-input-number v-model="form.sort" :min="0" :step="1" style="width: 160px"></el-input-number>
          <span class="muted small" style="margin-left: 10px">数值越小越靠前</span>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-switch
            v-model="form.enabled"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="停用"
          ></el-switch>
        </el-form-item>
        <el-form-item label="备注说明">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="请输入备注说明（如：普通试用、预收试用、品鉴试用等业务范围）"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="submitting">确定保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ApplicableType',
  data() {
    return {
      typeList: [],
      loading: false,
      dialogVisible: false,
      submitting: false,
      searchName: '',
      searchEnabled: null,
      form: this.emptyForm(),
      rules: {
        name: [{ required: true, message: '请输入试用类型名称', trigger: 'blur' }]
      },
      predefineColors: [
        '#409EFF',
        '#67C23A',
        '#E6A23C',
        '#F56C6C',
        '#909399',
        '#9B59B6',
        '#3498DB',
        '#1ABC9C',
        '#E74C3C',
        '#34495E'
      ]
    }
  },
  computed: {
    filteredTypes() {
      return this.typeList.filter(item => {
        const matchName = !this.searchName || (item.name && item.name.toLowerCase().includes(this.searchName.trim().toLowerCase()))
        const matchEnabled = this.searchEnabled === null || this.searchEnabled === '' || item.enabled === this.searchEnabled
        return matchName && matchEnabled
      })
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        name: '',
        color: '#409EFF',
        needVerification: 0,
        sort: 0,
        enabled: 1,
        remark: ''
      }
    },
    loadList() {
      this.loading = true
      axios.get('/applicable-type/list')
        .then(res => {
          this.typeList = Array.isArray(res.data) ? res.data : []
        })
        .catch(err => {
          this.$message.error('加载试用类型列表失败：' + (err.message || '网络错误'))
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDialog(row) {
      if (row) {
        this.form = { ...row }
      } else {
        this.form = this.emptyForm()
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitting = true
        const isEdit = !!this.form.id
        const req = isEdit
          ? axios.put('/applicable-type', this.form)
          : axios.post('/applicable-type', this.form)

        req.then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success(isEdit ? '修改试用类型成功' : '新增试用类型成功')
            this.dialogVisible = false
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '保存失败')
          }
        }).catch(err => {
          this.$message.error('请求失败：' + (err.message || '网络错误'))
        }).finally(() => {
          this.submitting = false
        })
      })
    },
    onDelete(row) {
      this.$confirm(`确定删除试用类型「${row.name}」吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '确定删除',
        cancelButtonText: '取消'
      }).then(() => {
        axios.delete('/applicable-type/' + row.id)
          .then(res => {
            if (res.data && res.data.success !== false) {
              this.$message.success('删除成功')
              this.loadList()
            } else {
              this.$message.error((res.data && res.data.message) || '删除失败')
            }
          })
          .catch(err => {
            this.$message.error('删除请求失败：' + (err.message || '网络错误'))
          })
      }).catch(() => {})
    },
    formatDate(v) {
      return v ? String(v).replace('T', ' ').slice(0, 19) : '-'
    }
  }
}
</script>

<style scoped>
.muted {
  color: #909399;
}
.small {
  font-size: 12px;
}
.mb-3 {
  margin-bottom: 14px;
}
</style>
